document.addEventListener("DOMContentLoaded", function () {
  function setBackgrounds() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const heroes = document.querySelectorAll(".hero-background");

    heroes.forEach(hero => {
      const mobileImage = hero.getAttribute("data-mobile");
      const desktopImage = hero.getAttribute("data-desktop");
      const imageToUse = isMobile ? mobileImage : desktopImage;

      if (imageToUse) {
        hero.style.backgroundImage = `url(${imageToUse})`;
      }
    });
  }

  function setVideoSources() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const videoSections = document.querySelectorAll(".hero-video");

    videoSections.forEach(section => {
      const video = section.querySelector("video");
      const source = video?.querySelector("source");

      const desktopVideo = section.getAttribute("data-desktop-video");
      const mobileVideo = section.getAttribute("data-mobile-video");
      const desktopPoster = section.getAttribute("data-desktop-poster");
      const mobilePoster = section.getAttribute("data-mobile-poster");

      const selectedVideo = isMobile ? mobileVideo : desktopVideo;
      const selectedPoster = isMobile ? mobilePoster : desktopPoster;

      if (video && source && selectedVideo) {
        if (source.src !== selectedVideo) {
          source.src = selectedVideo;
          video.poster = selectedPoster;
          video.load();
          video.play().catch(err => {
            console.warn("Autoplay blocked:", err);
          });
        }
      }
    });
  }

  function debounce(fn, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  const updateMedia = debounce(() => {
    setBackgrounds();
    setVideoSources();
  }, 200);

  setBackgrounds();
  setVideoSources();
  window.addEventListener("resize", updateMedia);
});
